var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('InsertTabs',{attrs:{"tab":_vm.tab,"hasFb":_vm.hasFb},on:{"checkInsertTab":_vm.checkInsertTab}}),_c(_vm.tab,{tag:"router-view",attrs:{"type":_vm.type,"hasFb":_vm.hasFb,"formData":_vm.formData,"checkList":_vm.checkList,"mobile":_vm.mobile},on:{"checkInsertTab":_vm.checkInsertTab}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }